import { FC } from 'react'

import { Icon, IconName } from '~/src/components/generic/PhosphorIcons/index'

import { tw } from '~/lib/utils'

type Props = {
  title: string
  icon: IconName
  onClick?: () => void
}

const SidebarAction: FC<Props> = ({ title, icon, onClick }) => {
  return (
    <button
      className={tw(
        'flex w-full cursor-pointer items-center justify-center py-2 transition hover:bg-ryder-red-primary/70 focus:bg-ryder-red-primary/70 focus:outline-none'
      )}
      key={title}
      type="button"
      onClick={onClick}
    >
      <div className="flex flex-col items-center space-y-2">
        <Icon color="#fff" name={icon} size="24" />
        <p className="text-label-xs font-normal text-inverted">{title}</p>
      </div>
    </button>
  )
}

export default SidebarAction
